import { dateTimeFormat } from "@/helpers/dateFormat";
import dayjs, { DateInput } from "@/utils/date";

type FormatTimeProps = {
  date: NonNullable<DateInput>;
  format?: string;
  utc?: boolean;
} & React.ComponentProps<"span">;

export function FormatTime({
  date,
  format = dateTimeFormat,
  utc = false,
  ...props
}: FormatTimeProps) {
  const d = utc ? dayjs.utc(date) : dayjs(date);
  return <span {...props}>{d.format(format)}</span>;
}
